import { render, staticRenderFns } from "./StartForm.vue?vue&type=template&id=5f88b1a8&scoped=true&"
import script from "./StartForm.vue?vue&type=script&lang=js&"
export * from "./StartForm.vue?vue&type=script&lang=js&"
import style0 from "./StartForm.vue?vue&type=style&index=0&id=5f88b1a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f88b1a8",
  null
  
)

export default component.exports